import { AppConfig } from '../types';
import { testConfig } from './testConfig';
import { preprodConfig } from './preprodConfig';
import { prodConfig } from './prodConfig';

export { testConfig, preprodConfig, prodConfig };

// Function to get config based on environment
export const getConfigByEnvironment = (env: string): AppConfig => {
  switch (env.toLowerCase()) {
    case 'prod':
    case 'production':
      return prodConfig;
    case 'preprod':
    case 'preproduction':
      return preprodConfig;
    case 'test':
    case 'development':
    case 'dev':
    default:
      return testConfig;
  }
};

// Resolved at build time via VITE_ENV — statically inlined by Vite
export const appConfig: AppConfig = getConfigByEnvironment(import.meta.env.VITE_ENV || 'test');
